import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "step-row__subtitle" }
const _hoisted_2 = { key: 0 }

import StepRowInformation from '@/brief-hub/deposit/overview/StepRowInformation.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StepRowCell',
  props: {
    label: {},
    value: {},
    mandatory: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.label), 1),
    (_ctx.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.value), 1))
      : (_openBlock(), _createBlock(StepRowInformation, {
          key: 1,
          mandatory: _ctx.mandatory
        }, null, 8, ["mandatory"]))
  ]))
}
}

})